import * as React from 'react';
import SimpleBar from 'simplebar-react';
import Text from 'components/core/Text';
import 'simplebar-react/dist/simplebar.min.css';

import { Wrapper, StyledProgramActivity } from './styles';

class Activities extends React.Component {
  componentDidMount() {
    const { requestFetchWorkoutSessionsProgram, programId } = this.props;
    requestFetchWorkoutSessionsProgram({
      programId,
    });
  }

  render() {
    const { activities } = this.props;

    if (!activities)
      return (
        <Text color="gray" pl={32} pt={25}>
          As you complete workouts you will see a summary here.
        </Text>
      );

    const activitiesLength = activities.filter((activity) => activity.workoutSurvey).length;
    const scrollHeight = activitiesLength > 2 ? '464px' : `${activitiesLength * 128 + 5}px`;

    return (
      <SimpleBar style={{ maxHeight: scrollHeight }}>
        <Wrapper>
          {activities
            ? activities.map((activity, id) => {
                if (!activity.workoutSurvey) return null;

                const { session } = activity;

                return (
                  <StyledProgramActivity
                    href={`/programs/${session.program.id}/sessions/${session.id}${
                      activity.trackSessionId ? `?trackSessionId=${activity.trackSessionId}` : ''
                    }`}
                    key={String(id)}
                    activity={activity}
                  />
                );
              })
            : null}
        </Wrapper>
      </SimpleBar>
    );
  }
}

export default Activities;
